type RequestPort = (path: string, options?: { method?: 'POST' | 'PUT' | 'DELETE'; body?: unknown }) => Promise<unknown>;

type ApiErrorBody = { error?: string };

export function createBrowserRequest(onUnauthorized: () => void): RequestPort {
  return async (path, options = {}) => {
    const res = await fetch(path, {
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      method: options.method,
      body: options.body === undefined ? undefined : JSON.stringify(options.body),
    });
    const data = ((await res.json().catch(() => ({}))) ?? {}) as ApiErrorBody;
    if (res.status === 401 && !path.includes('/api/auth/')) {
      onUnauthorized();
      throw new Error(data.error || 'Сессия истекла');
    }
    if (!res.ok) throw new Error(data.error || `Ошибка ${res.status}`);
    return data;
  };
}
